import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ControlEquiposDetallePage } from './control-equipos-detalle';
import { ComponentsModule } from '../../components/components.module'

@NgModule({
  declarations: [
    ControlEquiposDetallePage,
  ],
  imports: [
    IonicPageModule.forChild(ControlEquiposDetallePage),
    ComponentsModule
    
  ],
})
export class ControlEquiposDetallePageModule { }



// WEBPACK FOOTER //
// ./src/pages/control-equipos-detalle/control-equipos-detalle.module.ts